import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import wtyReportApi from "../../services/warrantyReportAxios";

const initialState = {
    searchCriteria: {
        searchType: '',
        serialNumber: ''
    },
    searchedText: String(''),
    claims: [],
    claimsFromClaimSearch: [],
    loading: false,
    error: null
}

export const getClaims = createAsyncThunk(
    "claimSearch/getClaims",
    async ({searchType, pin, claimNumber, searchFrom}) => {
    const claimSearchAPIUrl = "/claims/getClaims";
    let params;
    if (searchType === "ClaimNumber") {
        params = {
            "claimNumber": claimNumber
        }
    } else {
        params = {
            "pin": pin
        }
    }

    try {
        const response = await wtyReportApi.get(claimSearchAPIUrl, params);
        if (response.status !== 200) {
            new Error("Calling api to get claim list failed");
        }
        const claimData =  await response.data;
        return {claimData, searchFrom}

    } catch (error) {
        throw error;
    }
})

const claimSearchSlice = createSlice({
    name: "claimSearch",
    initialState,
    reducers: {
        setSearchText: (state, action) => {
            state.searchText = action.payload;
        },
        resetClaimState: (state) => initialState
    },
    extraReducers(builder) {
        builder
            .addCase(getClaims.pending, state => {
                state.loading = true;
                state.claims = [];
                state.error = undefined;
            })
            .addCase(getClaims.rejected, (state, action) => {
                state.loading = false;
                state.claims = [];
                state.error = action.error;
            })
            .addCase(getClaims.fulfilled, (state, action) => {
                state.loading = false;
                if(action.payload.searchFrom === "claimSearchForm"){
                    state.claimsFromClaimSearch = action.payload.claimData
                    if (state.claimsFromClaimSearch.length === 0){
                        state.error = "claimsNotFound";
                    } else {
                        state.error = undefined;
                    }
                } else {
                    state.claims = action.payload.claimData;
                    if (state.claims.length === 0){
                        state.error = "claimsNotFound";
                    } else {
                        state.error = undefined;
                    }
                }
            })
    }
})

export const { setSearchText, resetClaimState } = claimSearchSlice.actions

export const claimList = (state) => state.claims.claims;
export const claimListFromClaimSearchForm = (state) => state.claims.claimsFromClaimSearch;
export const claimsLoading = (state) => state.claims.loading;
export const claimsError = (state) => state.claims.error;
export const searchedText = (state) =>  state.claims.searchedText;

export default claimSearchSlice.reducer;